// import React, { useState, useEffect, useRef } from "react";
// import Sidebar from "../../../Components/Sidebar";
// import TopNav from "../../../Components/TopNav";
// import "react-loading-skeleton/dist/skeleton.css";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useParams, useNavigate } from "react-router-dom";
// import { deleteComboProductGalleryServ, getComboProductDetailsServ, updateComboProductGalleryServ, updateComboProductHeroImage, updateComboProductServ, updateComboProductVideoServ } from "../../../services/comboProduct.services";
// function ComboProductUpdateStep3() {
//   const navigate = useNavigate();
//   const params = useParams();
//   const uploadHeroImage = async (img) => {
//     try {
//       const formData = new FormData();
//       formData.append("productHeroImage", img);
//       formData.append("id", params.id);
//       let response = await updateComboProductHeroImage(formData);
//       if (response?.data?.statusCode == "200") {
//         toast.success(response?.data?.message);
//         getProductDetails()
//       } else {
//         toast.error("Something went wrong");
//       }
//     } catch (error) {
//       toast.error("Internal Server Error");
//     }
//   };
// //   const uploadProductVideo = async (video) => {
// //     try {
// //       const formData = new FormData();
// //       formData.append("productVideo", video);
// //       formData.append("id", params.id);
// //       let response = await updateComboProductVideoServ(formData);
// //       if (response?.data?.statusCode == "200") {
// //         toast.success(response?.data?.message);
// //         getProductDetails()
// //       } else {
// //         toast.error("Something went wrong");
// //       }
// //     } catch (error) {
// //       toast.error("Internal Server Error");
// //     }
// //   };

//   const uploadProductGalleryFunc = async (img) => {
//     try {
//       const formData = new FormData();
//       formData.append("productGallery", img);
//       formData.append("id", params.id);
//       let response = await updateComboProductGalleryServ(formData);
//       if (response?.data?.statusCode == "200") {
//         toast.success(response?.data?.message);
//         getProductDetails()
//       } else {
//         toast.error("Something went wrong");
//       }
//     } catch (error) {
//       toast.error("Internal Server Error");
//     }
//   };
//   const [details, setDetails] = useState({
//     productHeroImage: "",
//     productGallery: [],
//     // productVideo: "",
//   });
//   const getProductDetails = async () => {
//     try {
//       let response = await getComboProductDetailsServ(params?.id);
//       if (response?.data?.statusCode == "200") {
//         setDetails({
//           productHeroImage: response?.data?.data?.productHeroImage,
//           productGallery: response?.data?.data?.productGallery,
//         //   productVideo: response?.data?.data?.productVideo,
//         });
//       }
//     } catch (error) {}
//   };
//   useEffect(() => {
//     getProductDetails();
//   }, []);
//   const deleteProductGalleryFunc =async (index)=>{
//     try {
//       let response = await deleteComboProductGalleryServ({id:params?.id, index:index});
//       if(response?.data?.statusCode=="200"){
//         toast.success(response?.data?.message)
//         getProductDetails()
//       }
//     } catch (error) {
//       toast.error("Internal Server Error")
//     }
//   }

//    const handleSubmit = async () => {
//       const finalPayload = {
//         id: params?.id,
//       };
  
//       try {
//         let response = await updateComboProductServ(finalPayload);
//         if (response?.data?.statusCode === 200) {
//           toast.success(response?.data?.message);
//           navigate("/combo-product-list");
//         }
//       } catch (error) {
//         toast.error("Something went wrong");
//       }
//     };
//   return (
//     <div className="bodyContainer">
//       <Sidebar selectedMenu="Product Management" selectedItem="Add Combo Packs" />
//       <div className="mainContainer">
//         <TopNav />
//         <div className="p-lg-4 p-md-3 p-2">
//           <div
//             className="row mx-0 p-0"
//             style={{
//               position: "relative",
//               top: "-75px",
//               marginBottom: "-75px",
//             }}
//           ></div>

//           <div className="mt-3">
//             <div className="card-body px-2">
//               <div className="table-responsive table-invoice">
//                 <div className="d-flex">
//                   <h4
//                     className="p-2 text-dark shadow rounded mb-4 "
//                     style={{ background: "#05E2B5" }}
//                   >
//                     Update Packs : Step 3/3
//                   </h4>
//                 </div>
//               </div>
//               <div className="row">
//                 <div className="col-4 mb-3">
//                   <div className="border p-2">
//                     <div className="d-flex justify-content-center">
//                       <img
//                         src={
//                           details?.productHeroImage
//                             ? details?.productHeroImage
//                             : "https://cdn-icons-png.flaticon.com/128/159/159626.png"
//                         }
//                         className="img-fluid mb-2"
//                         style={{ height: "150px" }}
//                       />
//                     </div>
//                     <input
//                       className="form-control"
//                       type="file"
//                       onChange={(e) => uploadHeroImage(e?.target?.files[0])}
//                     />
//                     <label>Product Hero Image</label>
//                   </div>
//                 </div>
//                 {/* <div className="col-4 mb-3">
//                   <div className="border p-2">
//                     <div className="d-flex justify-content-center">
//                       {details?.productVideo ? (
//                         <video
//                           className="mb-2"
//                           style={{ height: "150px" }}
//                           src={details?.productVideo}
//                         ></video>
//                       ) : (
//                         <img
//                           src="https://cdn-icons-png.flaticon.com/128/16792/16792767.png"
//                           className="img-fluid mb-2"
//                         />
//                       )}
//                     </div>
//                     <input
//                       className="form-control"
//                       type="file"
//                       onChange={(e) => uploadProductVideo(e?.target?.files[0])}
//                     />
//                     <label>Product Video</label>
//                   </div>
//                 </div> */}
//                 <div className="col-12 mb-3">
//                   <label>Product Gallery</label>
//                   <div className="p-2 border d-flex">
//                     <div>
//                       <div className="d-flex justify-content-center">
//                         <img
//                           src="https://cdn-icons-png.flaticon.com/128/16792/16792767.png"
//                           className="img-fluid mb-2"
//                         />
//                       </div>
//                       <input
//                         className="form-control"
//                         type="file"
//                         onChange={(e) =>
//                           uploadProductGalleryFunc(e?.target?.files[0])
//                         }
//                       />
//                     </div>
//                     {details?.productGallery?.map((v, i) => {
//                       return (
//                         <div className="p-2 border mx-2">
//                           <div className="d-flex justify-content-end">
//                             <img
//                               style={{
//                                 height: "20px",
//                                 position: "relative",
//                                 marginBottom: "-20px",
//                               }}
//                               onClick={()=>deleteProductGalleryFunc(i)}
//                               src="https://cdn-icons-png.flaticon.com/128/9068/9068699.png"
//                             />
//                           </div>
//                           <img
//                             className="img-fluid"
//                             style={{ height: "150px" }}
//                             src={v}
//                           />
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </div>

//                 <div className="col-12">
//                   <button
//                     className="btn btn-primary w-100"
//                     style={{
//                       background: "#61ce70",
//                       border: "none",
//                       borderRadius: "24px",
//                     }}
//                     onClick={handleSubmit}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ComboProductUpdateStep3;


import React, { useState, useEffect } from "react";
import Sidebar from "../../../Components/Sidebar";
import TopNav from "../../../Components/TopNav";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams, useNavigate } from "react-router-dom";
import { IMAGE_BASE_URL } from "../../../utils/api_base_url_configration";


import {
  deleteComboProductGalleryServ,
  getComboProductDetailsServ,
  updateComboProductGalleryServ,
  updateComboProductHeroImage,
  updateComboProductServ,
} from "../../../services/comboProduct.services";

function ComboProductUpdateStep3() {

    const getImageUrl = (image) => {
    if (!image) return "";
    if (image.startsWith("http")) return image;
    return `${IMAGE_BASE_URL}${image}`;
  };

  const navigate = useNavigate();
  const params = useParams();

  const [details, setDetails] = useState({
    productHeroImage: "",
    productGallery: [],
  });

  const [btnLoader, setBtnLoader] = useState(false);

  /* ───────── Hero Upload ───────── */
  const uploadHeroImage = async (img) => {
    try {
      const formData = new FormData();

      formData.append("productHeroImage", img);
      formData.append("id", params.id);

      let response = await updateComboProductHeroImage(formData);

      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);
        getProductDetails();
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error("Internal Server Error");
    }
  };

  /* ───────── Gallery Upload ───────── */
  const uploadProductGalleryFunc = async (img) => {
    try {
      const formData = new FormData();

      formData.append("productGallery", img);
      formData.append("id", params.id);

      let response = await updateComboProductGalleryServ(formData);

      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);
        getProductDetails();
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error("Internal Server Error");
    }
  };

  /* ───────── Fetch Details ───────── */
  const getProductDetails = async () => {
    try {
      let response = await getComboProductDetailsServ(params?.id);

      if (response?.data?.statusCode == "200") {
        setDetails({
          productHeroImage:
            response?.data?.data?.productHeroImage,
          productGallery:
            response?.data?.data?.productGallery,
        });
      }
    } catch (error) {}
  };

  useEffect(() => {
    getProductDetails();
  }, []);

  /* ───────── Delete Gallery ───────── */
  const deleteProductGalleryFunc = async (index) => {
    try {
      let response = await deleteComboProductGalleryServ({
        id: params?.id,
        index: index,
      });

      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);
        getProductDetails();
      }
    } catch (error) {
      toast.error("Internal Server Error");
    }
  };

  /* ───────── Final Submit ───────── */
  const handleSubmit = async () => {
    setBtnLoader(true);

    const finalPayload = {
      id: params?.id,
    };

    try {
      let response = await updateComboProductServ(
        finalPayload
      );

      if (response?.data?.statusCode === 200) {
        toast.success(response?.data?.message);

        navigate("/combo-product-list");
      }
    } catch (error) {
      toast.error("Something went wrong");
    }

    setBtnLoader(false);
  };

  return (
    <div className="bodyContainer">
      <Sidebar
        selectedMenu="Product Management"
        selectedItem="Add Combo Packs"
      />

      <div className="mainContainer">
        <TopNav />

        <div className="af-page">

          {/* ───────── Header ───────── */}
          <div className="af-header">
            <div className="af-header-left">

              <button
                className="af-back-btn"
                onClick={() => navigate(-1)}
              >
                <i
                  className="ti ti-arrow-left"
                  aria-hidden="true"
                />
              </button>

              <div>
                <div className="af-page-title">
                  Update Combo Pack
                </div>

                <div className="af-breadcrumb">
                  Product Management &rsaquo;{" "}
                  <span>Step 3 — Media Uploads</span>
                </div>
              </div>
            </div>

            <div className="af-step-badge">
              <span className="af-step-num">Step 3</span>
              of 3 — Media Uploads
            </div>
          </div>

          {/* ───────── Hero Image ───────── */}
          <div className="af-card">

            <div className="af-section-title">
              <i
                className="ti ti-photo"
                aria-hidden="true"
              />
              Hero Image
            </div>

            <div className="af-grid af-grid-3">

              <div className="af-field">

                <div className="af-banner-wrap">

                 
                {details?.productHeroImage ? (
  <img
    src={getImageUrl(details?.productHeroImage)}
    alt="Hero"
    className="af-banner-preview"
  />
) : (
  <div className="af-banner-placeholder">
    <i className="ti ti-photo" />
    <p>No Hero Image Uploaded</p>
  </div>
)}
                </div>

                <input
                  className="af-file-input"
                  type="file"
                  onChange={(e) =>
                    uploadHeroImage(
                      e?.target?.files[0]
                    )
                  }
                />

                <div className="af-helper">
                  Recommended: 500 × 500 px
                </div>

              </div>

            </div>
          </div>

          {/* ───────── Gallery ───────── */}
          <div className="af-card">

            <div className="af-section-title">
              <i
                className="ti ti-layout-grid"
                aria-hidden="true"
              />
              Product Gallery
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  "repeat(auto-fill,minmax(180px,1fr))",
                gap: "18px",
              }}
            >

              {/* Upload Box */}
              <div
                style={{
                  border: "1px dashed #e5dede",
                  borderRadius: "16px",
                  padding: "16px",
                  background: "#fafafa",
                }}
              >
                <div className="af-banner-placeholder">
                  <i className="ti ti-upload" />
                  <p>Upload Gallery Image</p>
                </div>

                <input
                  className="af-file-input"
                  type="file"
                  onChange={(e) =>
                    uploadProductGalleryFunc(
                      e?.target?.files[0]
                    )
                  }
                />
              </div>

              {/* Gallery Images */}
              {details?.productGallery?.map((v, i) => {
                return (
                  <div
                    key={i}
                    style={{
                      border: "1px solid #f0eded",
                      borderRadius: "16px",
                      padding: "12px",
                      background: "#fff",
                      position: "relative",
                    }}
                  >

                    <button
                      onClick={() =>
                        deleteProductGalleryFunc(i)
                      }
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        border: "none",
                        background: "#fff5f5",
                        color: "#e74c3c",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow:
                          "0 2px 10px rgba(0,0,0,0.08)",
                      }}
                    >
                      <i className="ti ti-trash" />
                    </button>

                    <img
                      className="img-fluid"
                      style={{
                        height: "180px",
                        width: "100%",
                        objectFit: "cover",
                        borderRadius: "12px",
                      }}
                        src={getImageUrl(v)}
                      alt="Gallery"
                    />
                  </div>
                );
              })}

            </div>
          </div>

          {/* ───────── Actions ───────── */}
          <div
            className="af-card"
            style={{ padding: "20px 28px" }}
          >
            <div className="af-actions">

              <span className="af-required-note">
                Finalize combo pack setup
              </span>

              <button
                className="af-cancel-btn"
                onClick={() => navigate(-1)}
              >
                <i
                  className="ti ti-arrow-left"
                  style={{ marginRight: "6px" }}
                  aria-hidden="true"
                />
                Back
              </button>

              <button
                className="af-next-btn"
                onClick={!btnLoader ? handleSubmit : undefined}
                disabled={btnLoader}
              >
                {btnLoader ? (
                  <>
                    <i
                      className="ti ti-loader-2 af-spin"
                      aria-hidden="true"
                    />
                    Submitting...
                  </>
                ) : (
                  <>
                    Finish & Submit
                    <i
                      className="ti ti-check"
                      aria-hidden="true"
                    />
                  </>
                )}
              </button>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default ComboProductUpdateStep3;